"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShimmerCircle = void 0;
var Utilities_1 = require("../../../Utilities");
var ShimmerCircle_styles_1 = require("./ShimmerCircle.styles");
var ShimmerCircle_base_1 = require("./ShimmerCircle.base");
exports.ShimmerCircle = (0, Utilities_1.styled)(ShimmerCircle_base_1.ShimmerCircleBase, ShimmerCircle_styles_1.getStyles, undefined, { scope: 'ShimmerCircle' });
//# sourceMappingURL=ShimmerCircle.js.map